var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.shownNotes),function(note){return _c('note',{key:note.id,attrs:{"note":note,"only":_vm.only}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }